function capitalizeFirstLettersOfAllWordsInString(str) {
  return str.split(' ').map((st) => st.charAt(0).toUpperCase() + st.substring(1)).join(' ');
}

export function createListTitle({q, type}) {
  const queryCapitalized = capitalizeFirstLettersOfAllWordsInString(q);
  const queryStr = type ? queryCapitalized : `"${queryCapitalized}"`;
  const lastWordInString = queryCapitalized.split(' ').pop();
  // Regular expression to see if string matches 'pass(es) or package(s)' string
  const regex = new RegExp('package[s]?|pass(es)?');
  // Checking for pass of last word in the query string
  const lastWordPassesRegex = regex.test(lastWordInString.toLowerCase());

  // Formatted return string. If the last word passed the regex, do not display 'Tickets' text at end
  return {title: queryStr, hasSuffix: !lastWordPassesRegex}; 
}